export const messages = {
    en: {
        reportCommunitySpace: {
            selectMonth: 'Select month',
            appointmentTime: 'Appointment Time',
            noSpace: 'No space set',
            available: 'Available',
            notAvailable: 'Not available'
        },
        addCommunitySpacePerson: {
            title: 'Venue Reservation',
            personName: 'Reserver Name',
            personTel: 'Reserver Phone',
            receivableAmount: 'Receivable Amount',
            receivedAmount: 'Received Amount',
            payWay: 'Payment Method',
            appointmentTime: 'Appointment Time',
            remark: 'Remark',
            requiredPersonName: 'Required, please enter reserver name',
            requiredPersonTel: 'Required, please enter reserver phone',
            requiredReceivableAmount: 'Required, please enter receivable amount',
            requiredReceivedAmount: 'Required, please enter received amount',
            selectPayWay: 'Please select payment method',
            requiredAppointmentTime: 'Required, please enter appointment time',
            requiredRemark: 'Required, please enter remark',
            maxPersonName: 'Reserver name cannot exceed 64 characters',
            maxPersonTel: 'Reserver phone cannot exceed 11 characters',
            maxReceivableAmount: 'Receivable amount cannot exceed 10 characters',
            maxReceivedAmount: 'Received amount cannot exceed 10 characters',
            maxRemark: 'Remark cannot exceed 512 characters',
            cash: 'Cash',
            wechat: 'WeChat',
            alipay: 'Alipay',
            requiredPayWay: 'Please select payment method'
        }
    },
    zh: {
        reportCommunitySpace: {
            selectMonth: '请选择月份',
            appointmentTime: '预约时间',
            noSpace: '未设置场地',
            available: '可预约',
            notAvailable: '不可预约'
        },
        addCommunitySpacePerson: {
            title: '场地预约',
            personName: '预约人',
            personTel: '预约电话',
            receivableAmount: '应收金额(元)',
            receivedAmount: '实收金额(元)',
            payWay: '支付方式',
            appointmentTime: '预约时间',
            remark: '备注',
            requiredPersonName: '必填，请填写预约人',
            requiredPersonTel: '必填，请填写预约电话',
            requiredReceivableAmount: '必填，请填写应收金额(元)',
            requiredReceivedAmount: '必填，请填写实收金额(元)',
            selectPayWay: '请选择支付方式',
            requiredAppointmentTime: '必填，请填写预约时间',
            requiredRemark: '必填，请填写备注',
            maxPersonName: '预约人不能超过64个字符',
            maxPersonTel: '预约电话不能超过11个字符',
            maxReceivableAmount: '应收金额(元)不能超过10个字符',
            maxReceivedAmount: '实收金额(元)不能超过10个字符',
            maxRemark: '备注不能超过512个字符',
            cash: '现金',
            wechat: '微信',
            alipay: '支付宝',
            requiredPayWay: '请选择支付方式'
        }
    }
}
